import BalanceService from '../services/balance.service';

const user = JSON.parse(localStorage.getItem('user'));
const initialState = user
  ? { status: { loggedIn: true }, user }
  : { status: { loggedIn: false }, user: null };

export const balance = {
  namespaced: true,
  state: initialState,
  actions: {
    sendBalance({ commit }, data) {
      return BalanceService.sendBalance(data).then(
        data => {
          commit('sendSuccess', data);
          return Promise.resolve(data);
        },
        error => {
          commit('sendFailure');
          return Promise.reject(error);
        }
      );
    }
  }
};
